import React from 'react';
import { useSelector } from 'react-redux';
import ComponentPreview from 'containers/Components/ComponentDetails/ComponentPreview';
import SpecificationPreview from 'containers/Specifications/SpecificationPreview/SpecificationPreview';
import Chat from 'layout/organisms/Chat';
import ScreenCropperController from 'layout/organisms/ScreenCropper/ScreenCropperController';
import { selectSidebars } from 'store/layoutSlice';
function SidebarsManager() {
    const showSidebars = useSelector(selectSidebars);
    const get = (name) => showSidebars.find((s) => s.name === name);
    return (React.createElement(React.Fragment, null,
        get('chat') && React.createElement(Chat, null),
        get('screenshot') && React.createElement(ScreenCropperController, null),
        get('specificationPreview') && React.createElement(SpecificationPreview, null),
        get('componentPreview') && React.createElement(ComponentPreview, null),
        get('sharedComponentPreview') && React.createElement(ComponentPreview, { shared: true })));
}
export default SidebarsManager;
